module.exports = __webpack_public_path__ + "img/icon5.8056e42f.png";